export default __webpack_public_path__ + "static/media/Logout.27748e0a.svg";